import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

class Partners {
    constructor(root) {
        this.root = root;
        this.title = this.root.querySelector('[data-partners--title]');
        this.logos = this.root.querySelectorAll('[data-partners--logo]');
        
        this.init();
    }

    init() {
        this.anim = gsap.timeline({
            scrollTrigger: {
                trigger: this.root,
                start: 'top 90%',
                end: 'bottom 10%',
                // markers: true,
            },
        })
            .fromTo(this.title, {
                opacity: 0,
            }, {
                opacity: 1,
                duration: 0.3,
                ease: 'out',
            }, '#start')
            .fromTo(this.logos, {
                opacity: 0,
            }, {
                opacity: 1,
                duration: 0.7,
                stagger: 0.1,
                ease: 'out',
            }, '#start+=0.1');
    }

    destroy() {
        this.anim && this.anim.kill();
    }
}

export default {
    when() {
        return document.querySelectorAll('[data-partners]').length > 0
    },

    created() {
        this.instances = [];
        document.querySelectorAll('[data-partners]').forEach(root => {
            const instance = new Partners(root);
            this.instances.push(instance);
        })
    },

    destroyed() {
        this.instances.forEach(instance => {
            instance.destroy && instance.destroy();
        });
    }
}
